import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Junta classes e resolve conflitos do Tailwind (o último `w-*`, `h-*`, `px-*`… ganha). */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
